module.exports = __webpack_public_path__ + "static/media/popup01.2d17cb6c.png";